import React from 'react';
import { CheckIcon, LockIcon, MonitorIcon, ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { HERO_IMAGE } from '../data/content';
import { HERO_SIZES, HERO_WIDTHS, optimizedImage, optimizedSrcSet } from '../utils/images';
const highlights = ['6 Digital Volumes', 'Solved Clinical Cases', 'Rubrics & Semester Planning'];
const trustItems = [{
  icon: StarIcon,
  label: '4.9/5 Faculty rating'
}, {
  icon: ShieldCheckIcon,
  label: '7-Day guarantee'
}, {
  icon: MonitorIcon,
  label: '100% digital'
}, {
  icon: LockIcon,
  label: 'Secure checkout'
}];
export function Hero() {
  return <header className="w-full bg-cream-100 px-5 pb-5 pt-2 sm:px-6 sm:pb-6" data-id="element-91" data-mp="s9q7jpfyirex">
      <div className="mx-auto flex w-full max-w-5xl flex-col items-center text-center" data-id="element-92" data-mp="nczvreb6qhzb">
        <span className="inline-flex items-center gap-2 rounded-full bg-forest-800 px-3.5 py-1 text-[0.6rem] font-semibold uppercase tracking-[0.22em] text-cream-50 sm:px-4 sm:py-1.5 sm:text-xs" data-id="element-93" data-mp="3d21v45faeyrf">
          <span className="h-1.5 w-1.5 rounded-full bg-ember-400" aria-hidden="true" data-id="element-94" data-mp="3j7zhlpe3m4ju" />
          Surgical Shield System 2026
        </span>

        <h1 className="mt-2.5 font-display text-[1.6rem] font-bold uppercase leading-[0.98] tracking-tight text-forest-900 sm:mt-3 sm:text-[2.6rem] lg:text-[3.4rem]" data-id="element-95" data-mp="3o73p8bldju82">
          Your Surgical Technology Curriculum,
          <span className="block text-ember-500" data-id="element-96" data-mp="3ebisarv5xk56">Ready Today.</span>
        </h1>

        <img src={optimizedImage(HERO_IMAGE, 540)} srcSet={optimizedSrcSet(HERO_IMAGE, HERO_WIDTHS)} sizes={HERO_SIZES} alt="The Surgical Shield System 2026: six digital volumes plus five bonuses for surgical technology faculty" width={1000} height={1000} fetchPriority="high" decoding="async" className="-my-3 h-auto w-full max-w-[26rem] object-contain sm:-my-5 sm:max-w-[34rem]" data-id="element-97" data-mp="30ggfdkrweuiv" />

        <p className="max-w-2xl text-[0.78rem] leading-snug text-forest-600 sm:text-base" data-id="element-98" data-mp="2ljpef72ktar5">
          The complete resource suite for Surgical Technology faculty —{' '}
          <span className="font-semibold text-forest-800" data-id="element-99" data-mp="nbl1chqpya8v">
            plan, explain, assess and teach real OR practice
          </span>{' '}
          without starting from scratch.
        </p>

        <ul className="mt-2.5 flex flex-wrap items-center justify-center gap-1.5 sm:mt-3 sm:gap-2" data-id="element-100" data-mp="ddf5agrlfybx">
          {highlights.map(item => <li key={item} className="flex items-center gap-1.5 rounded-full border border-cream-300 bg-cream-50 px-2.5 py-1 text-[0.62rem] font-semibold uppercase tracking-wide text-forest-800 sm:px-3 sm:py-1.5 sm:text-xs" data-id="element-101" data-mp="1azkvzsr5iksq">
              <CheckIcon className="h-3 w-3 text-ember-500 sm:h-3.5 sm:w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-102" data-mp="x1nwanhehy9u" />
              {item}
            </li>)}
        </ul>

        <CtaButton className="mt-3.5 sm:mt-4" label="Get My Shield System" source="hero" data-id="element-103" data-mp="3hrd7mqiwb1xs" />

        <div className="mt-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[0.65rem] text-forest-600 sm:mt-3 sm:gap-x-4 sm:text-xs" data-id="element-104" data-mp="3htpy5s2pykmg">
          {trustItems.map(({
          icon: Icon,
          label
        }, index) => <React.Fragment key={label} data-id="element-105" data-mp="26a98hgz9d4u3" data-mpi={index}>
              {index > 0 ? <span className="hidden h-3 w-px bg-cream-300 sm:block" aria-hidden="true" data-id="element-106" data-mp="267wlgpen84a6" /> : null}
              <span className="flex items-center gap-1.5" data-id="element-107" data-mp="2fzss4ousp2q0">
                <Icon className={`h-3 w-3 sm:h-3.5 sm:w-3.5 ${index === 0 ? 'fill-ember-400 text-ember-400' : 'text-ember-500'}`} aria-hidden="true" data-id="element-108" data-mp="2fzanb3u2hg6h" />
                {label}
              </span>
            </React.Fragment>)}
        </div>
      </div>
    </header>;
}